import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import PropTypes from 'prop-types';
import Impression from './impression';

var ProductImpression = function ProductImpression(props) {
  var impressionProps = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    id: props.id,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    children: props.children,
    eventData: _objectSpread({
      impressionHeader: {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productId: props.productId,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productSlug: props.productSlug,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productLocation: props.productLocation,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        vertical: props.vertical,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        category: props.category,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productInstance: props.productInstance,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        linkType: props.linkType,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sponsored: props.sponsored,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        monetizing: props.monetizing,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productPosition: props.productPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sectionPosition: props.sectionPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        offerVersionId: props.offerVersionId,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        brainEventHeader: props.brainEventHeader,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productDisplayDriver: props.productDisplayDriver
      }
    }, props.additionalEventData)
  };
  return /*#__PURE__*/React.createElement(Impression, impressionProps);
};

ProductImpression.propTypes = {
  id: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  productSlug: PropTypes.string.isRequired,
  productLocation: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
  children: PropTypes.element,
  category: PropTypes.string,
  productInstance: PropTypes.string,
  linkType: PropTypes.string,
  sponsored: PropTypes.bool,
  monetizing: PropTypes.bool,
  productPosition: PropTypes.number,
  sectionPosition: PropTypes.number,
  offerVersionId: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  brainEventHeader: PropTypes.object,
  productDisplayDriver: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  additionalEventData: PropTypes.object
};
ProductImpression.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  productLocation: 'body',
  productInstance: 'unknown',
  linkType: 'unknown'
};
export default ProductImpression;